<template>
  <!-- BEGIN pos-counter -->
  <div class="pos pos-counter ts-overflow-hidden" v-bind:class="{ 'pos-mobile-sidebar-toggled': posMobileSidebar }"
    id="pos-counter">
    <!-- Hidden NFC Scanner Component -->
    <!-- @nfc-scanned="handleNFCScan" -->
    <NFCScanner ref="nfcScanner" @scan-started="handleScanStarted" @scan-ended="handleScanEnded"
      @scan-success="handleScanSuccess" @scan-error="handleScanError" @scanner-ready="handleScannerReady" />

    <!-- Header Component -->
    <PosCounterHeader :time="time" :tableBusy="tableBusy" :totalTable="totalTable" :flag="flag" :languages="languages"
      :fullscreen="fullscreen" :lock.sync="lock" @openFullscreen="openFullscreen" @closeFullscreen="closeFullscreen"
      @changeLanguage="changeLanguage" @onChangeLock="onChangeLock" />

    <!-- Body Component -->
    <PosCounterBody :tableLists="tableLists" :tableFetching="tableFetching" :selected_table="selected_table"
      :tableSelected="tableSelected" :posMobileSidebar="posMobileSidebar" :defaultCrrency="defaultCrrency"
      :vatRate="vatRate" :printing="printing" @onTableSelected="onTableSelected"
      @posMobileSidebarToggled="posMobileSidebarToggled" @removeItem="removeItem"
      @showCombineTableForm="showCombineTableForm" @moveTable="moveTable" @cleanTable="cleanTable"
      @cancelOrder="cancelOrder" @addMoreOrder="addMoreOrder" @printBill="printBill" @showBillForm="showBillForm"
      @showShiftCloseForm="showShiftCloseForm" @showLinkedKeysForm="
        () => ((showLinkedKeysForm = true), (posMobileSidebar = false))
      " @fetchTableByInterval="fetchTableByInterval" />

    <!-- Modals -->
    <a-modal v-if="showForm" v-model="showForm" :title="$t('restaurantSale.shiftClose')" centered @cancel="closeForm"
      :zIndex="1020" :footer="null" width="400px">
      <shift-close @cancel="closeForm" @preview="receiptPreview" />
    </a-modal>

    <a-modal v-if="showLinkedKeysForm" v-model="showLinkedKeysForm" :title="$t('restaurantSale.linkedKey')" centered
      @cancel="closeLinkedKeysForm" :zIndex="1020" :footer="null" width="80%">
      <linked-keys :tableSelected="tableSelected" @cancel="closeLinkedKeysForm" />
    </a-modal>

    <modal name="modalLock" height="auto" width="450px" :scrollable="true" draggable=".form-header"
      :clickToClose="false">
      <div class="ts-p-6">
        <div class="ts-space-y-4">
          <label
            class="col-form-label ts-mb-3 ts-font-bold ts-w-full ts-px-2 bg-success ts-flex ts-justify-items-center ts-items-center"
            style="height: 45px;">
            <i class="fa fa-key fa-fw fa-lg ts-pb-1" style="color: white;"></i>
            <h4 style="margin: 0 !important;color: white;" class="ts-pl-2">
              {{ $t('restaurantSale.unlock') }}
            </h4>
          </label>
          <div class="ts-border-t ts-border-gray-300 ts-pt-4">
            <div>
              {{ $t('restaurantSale.password') }}
            </div>
            <div class="form-group m-b-20">
              <input :type="input_type" class="form-control form-control-lg" placeholder="Password" required
                v-model.trim="password" @keyup.enter="onUnlock" ref="password" />
              <a href="#" @click.prevent="showPassword">
                <i v-if="input_type === 'text'" class="toggle-password fas fa-eye"></i>
                <i v-else class="toggle-password fa fa-fw fa-eye-slash"></i>
              </a>
            </div>
            <div class="alert alert-danger fade show m-b-20" v-if="errors.has('password')">
              {{ errors.first('password') }}
            </div>
          </div>
          <div class="btn-row ts-space-x-2 ts-text-right ts-border-t ts-border-gray-300 ts-pt-4">
            <ts-button @click.prevent="onCancelLock"><i class="fa fa-arrow-left fa-fw fa-lg"></i>
              {{ $t('restaurantSale.back') }}</ts-button>
            <ts-button color="success" @click.prevent="onUnlock" :waiting="loading" :disabled="loading">
              {{ $t('restaurantSale.unlock') }}</ts-button>
          </div>
        </div>
      </div>
    </modal>

    <a-modal v-if="showPreviewReciept" v-model="showPreviewReciept" :title="$t('restaurantSale.previewReciept')"
      centered @cancel="closeForm" :zIndex="1020" :footer="null" width="400px">
      <shift-close @cancel="closeForm" @preview="receiptPreview" />
    </a-modal>
  </div>
  <!-- END pos-counter -->
</template>

<script>
import PageOptions from '@/config/PageOptions.vue'
// import NumberCustomer from './counter-checkout-components/number-of-customer'
import CombineTable from './counter-checkout-components/combine-table'
import MoveTable from './counter-checkout-components/move-table'
import CheckBill from './counter-checkout-components/check-bill'
import ShiftClose from './counter-checkout-components/shift-close'
import LinkedKeys from './counter-checkout-components/linked-keys.vue'
import PosCounterHeader from './counter-checkout-components/PosCounterHeader.vue'
import PosCounterBody from './counter-checkout-components/PosCounterBody.vue'
import NFCScanner from './counter-checkout-components/NFCBackgroundListener.vue'
import { mapActions } from 'vuex'
import Vmodal from 'vue-js-modal'
import Vue from 'vue'
Vue.use(Vmodal, { dynamic: true, injectModalsContainer: true })
import Reason from './components/reason-delete'
import { Errors } from 'form-backend-validation'

export default {
  components: {
    ShiftClose,
    LinkedKeys,
    PosCounterHeader,
    PosCounterBody,
    NFCScanner
  },
  created() {
    PageOptions.pageEmpty = true
    PageOptions.pageFullHeight = true
    this.handleStartTime()
    this.fetchTables()
    this.fetchProducts()
    this.fetchBefore().finally(() => {
      this.defaultCheckTable(this.table_id)
    })
  },
  mounted() {
    if ('NDEFReader' in window) {
      this.startScan()
      this.initializeSounds()
    }
    this.interval = setInterval(() => {
      this.fetchTableByInterval()
    }, 30000)
    // Configure scanner if needed
    this.$nextTick(() => {
      if (this.$refs.nfcScanner) {
        // Set custom validation parameters
        this.$refs.nfcScanner.setMinLength(6) // Minimum 6 characters
        this.$refs.nfcScanner.setMaxLength(30) // Maximum 30 characters
        this.$refs.nfcScanner.setScanDelay(150) // Wait 150ms after last key
      }
    })
  },
  beforeDestroy() {
    // Clean up resources
    this.stopScan()
    this.clearProcessingState()

    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
    // Clean up audio object
    if (this.scanSound) {
      this.scanSound.pause()
      this.scanSound = null
    }
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false
    PageOptions.pageFullHeight = false
    next()
  },
  data: function () {
    return {
      model: {
        deleted_reason: null
      },
      counter: {
        counter_id: undefined
      },
      time: '00:00',
      tableFetching: false,
      loading: false,
      printing: false,
      cleaning: false,
      posMobileSidebar: false,
      showForm: false,
      showLinkedKeysForm: false,
      showPreviewReciept: false,
      selected_table: 0,
      tableSelected: {},
      languages: [
        { code: 'kh', icon: 'kh', caption: 'ខ្មែរ' },
        { code: 'en', icon: 'us', caption: 'English' }
      ],
      interval: null,
      fullscreen: false,
      errors: new Errors(),
      message: 'Ready to scan NFC tags...',
      ndef: null,
      interval: null,
      isScanning: false,
      isProcessingFee: false,
      processingSerialNumbers: new Set(), // Track currently processing serial numbers
      lastProcessedSerial: null,
      lastProcessedTime: 0,
      audioContext: 'scan',
      scannerActive: false,
      input_type: 'password',
      password: null,
      scanSound: null
    }
  },
  computed: {
    tableLists() {
      return _.sortBy(this.$store.state.restaurantSale.counterCheckout.tables, [
        'display_order'
      ])
    },
    table_id() {
      return this.$store.state.restaurantSale.counterCheckout.tableSelected
        .table_id
    },
    vatRate() {
      return parseFloat(
        this.$store.state.restaurantSale.customerOrder.systemSettings.vat_rate
      )
    },
    exchangeRate() {
      return parseFloat(
        this.$store.state.restaurantSale.customerOrder.systemSettings.fx_rate
      )
    },
    defaultCrrency() {
      return this.$store.state.restaurantSale.customerOrder.systemSettings
        .default_currency
    },
    toCurrency() {
      return this.$store.state.restaurantSale.customerOrder.systemSettings
        .to_currency
    },
    flag() {
      if (this.$root.$i18n.locale === 'kh') return 'kh'
      else if (this.$root.$i18n.locale === 'en') return 'us'
    },
    tableBusy() {
      return this.tableLists.filter(t => t.status_id != 1).length
    },
    totalTable() {
      return this.tableLists.length
    },
    lock: {
      get() {
        return this.$store.state.restaurantSale.counterCheckout.lock
      },
      set(newValue) {
        this.$store.commit('restaurantSale/counterCheckout/SET_LOCK', newValue)
      }
    }
  },
  methods: {
    ...mapActions('restaurantSale/customerOrder', ['fetchBefore']),
    fetchProducts(attributes) {
      this.$store.dispatch(
        'restaurantSale/customerOrder/fetchProducts',
        attributes
      )
    },
    fetchTableByInterval(attributes) {
      this.$store
        .dispatch('restaurantSale/counterCheckout/fetchTables', attributes)
        .catch(error => {
          this.$notification['error']({
            message: 'FETCH TABLE',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => this.defaultCheckTable(this.tableSelected.table_id))
    },
    fetchTables(attributes) {
      this.tableFetching = true
      this.$store
        .dispatch('restaurantSale/counterCheckout/fetchTables', attributes)
        .catch(error => {
          this.$notification['error']({
            message: 'FETCH TABLE',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => (this.tableFetching = false))
    },
    cleanTable() {
      this.posMobileSidebar = !this.posMobileSidebar
      this.cleaning = true
      this.$store
        .dispatch('restaurantSale/counterCheckout/cleanTable', this.table_id)
        .then(response => {
          this.laodAndClearTable()
          if (response.message_id == 0) {
            this.$notification['success']({
              message: 'Clean Table',
              description: response.messages,
              placement: 'bottomRight'
            })
          } else {
            this.$notification['warning']({
              message: 'Clean Table',
              description: response.messages,
              placement: 'bottomRight'
            })
          }
        })
        .catch(error => {
          this.$notification['error']({
            message: 'Clean Table',
            description: error.messages,
            placement: 'bottomRight'
          })
        })
        .finally(() => (this.cleaning = false))
    },
    moveTable() {
      this.posMobileSidebar = !this.posMobileSidebar
      this.$modal.show(
        MoveTable,
        {
          data: {}
        },
        {
          height: 'auto',
          width: '350px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: true
        }
      )
    },
    onTableSelected(table) {
      this.openFullscreen()
      setTimeout(() => {
        this.posMobileSidebar = false
        this.selected_table = 0
        this.tableSelected = {}
        this.$store.commit(
          'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
          {}
        )
        if (table.status_id == 1) {
          this.selected_table = 0
          this.tableSelected = {}
          this.$store.commit(
            'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
            {}
          )
          this.addOrder(table)
        }
        if (table.status_id == 2) {
          this.selected_table = 0
          this.tableSelected = {}
          this.$store.commit(
            'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
            {}
          )
          this.showConfirm(table)
        }
        if (table.status_id == 3) {
          this.posMobileSidebar = !this.posMobileSidebar
          this.$store.commit(
            'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
            table
          )
          this.tableSelected = table
          this.selected_table = table.table_id
          // if (table.table_id == this.table_id) {
          //   this.selected_table = 0
          //   this.tableSelected = {}
          //   this.$store.commit(
          //     'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
          //     {}
          //   )
          // } else {
          //   this.posMobileSidebar = !this.posMobileSidebar
          //   this.$store.commit(
          //     'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
          //     table
          //   )
          //   this.tableSelected = table
          //   this.selected_table = table.table_id
          // }
        }
      }, 500)
    },
    addOrder(table) {
      this.$store.commit(
        'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
        table
      )
      this.$router.push({ name: 'customer-restaurant-order' })
    },
    async removeItem(item) {
      await this.$store
        .dispatch('restaurantSale/customerOrder/deleteItemOrdered', item)
        .then(() => {
          this.tableSelected.invoice_detail.splice(
            this.tableSelected.invoice_detail.indexOf(item),
            1
          )
        })
        .catch(error => {
          this.$toasted.error(error.messages)
        })
        .finally(() => {
          this.$store
            .dispatch('restaurantSale/counterCheckout/fetchTables')
            .finally(() => this.defaultCheckTable(this.tableSelected.table_id))
        })
    },
    posMobileSidebarToggled: function () {
      this.posMobileSidebar = !this.posMobileSidebar
    },
    defaultCheckTable(table_id) {
      if (table_id) {
        this.autoSelectedTable(
          this.$store.state.restaurantSale.counterCheckout.tables
            .filter(t => t.table_id == table_id)
            .reduce((init, value) => (init = value), {})
        )
      }
      // else {
      //   this.autoSelectedTable(
      //     this.$store.state.restaurantSale.counterCheckout.tables
      //       .filter(t => t.status_id == 3)
      //       .reduce((init, value) => (init = value), {})
      //   )
      // }
    },
    autoSelectedTable(table) {
      if (table.status_id == 3) {
        this.$store.commit(
          'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
          table
        )
        this.tableSelected = table
        this.selected_table = table.table_id
      }
    },
    addMoreOrder() {
      this.$router.push({ name: 'customer-restaurant-order' })
    },
    showCombineTableForm(table) {
      this.posMobileSidebar = !this.posMobileSidebar

      // Disable NFC scanner
      if (this.$refs.nfcScanner) {
        this.$refs.nfcScanner.disableScanner()
      }

      this.$modal.show(
        CombineTable,
        {
          data: table
        },
        {
          height: 'auto',
          width: '100%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: true
        },
        {
          'before-close': () => {
            // Re-enable scanner when closing
            if (this.$refs.nfcScanner) {
              this.$refs.nfcScanner.enableScanner()
            }
          }
        }
      )
    },
    showBillForm(table) {
      this.posMobileSidebar = !this.posMobileSidebar

      // Disable NFC scanner when bill modal opens
      if (this.$refs.nfcScanner) {
        this.$refs.nfcScanner.disableScanner()
      }

      this.$modal.show(
        CheckBill,
        {
          data: table
        },
        {
          height: 'auto',
          width: '60%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.laodAndClearTable
        }
      )
    },
    laodAndClearTable() {
      // Re-enable NFC scanner when bill modal closes
      if (this.$refs.nfcScanner) {
        this.$refs.nfcScanner.enableScanner()
      }

      this.tableSelected = {}
      this.selected_table = 0
      this.fetchTables()
    },
    handleCheckTime: function (i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    handleStartTime: function () {
      var today = new Date()
      var h = today.getHours()
      var m = today.getMinutes()
      var a
      m = this.handleCheckTime(m)
      a = h > 11 ? ' PM' : ' AM'
      h = h > 12 ? h - 12 : h

      this.time = h + ':' + m + a
      setTimeout(() => {
        this.handleStartTime()
      }, 500)
    },
    showConfirm(table) {
      const self = this
      setTimeout(() => {
        this.$confirm({
          title: table.num_pax_order_book_status,
          content: this.$t('restaurantSale.doYouWantToCleanTableAndMakeOrder'),
          onOk() {
            self.isCustomerCome(table)
          },
          okText: 'Yes',
          cancelText: 'No',
          centered: true,
          onCancel() {
            self.$destroyAll()
          }
        })
      }, 500)
    },
    isCustomerCome(table) {
      this.$store
        .dispatch(
          'restaurantSale/counterCheckout/isCustomerCome',
          table.booking_id
        )
        .then(() => {
          this.laodAndClearTable()
          this.addOrder(table)
        })
        .catch(error => {
          this.$notification['error']({
            message: 'Clean Table',
            description: error.messages,
            placement: 'bottomRight'
          })
        })
    },
    closeForm() {
      this.showForm = false
      // Re-enable NFC scanner when form closes
      if (this.$refs.nfcScanner) {
        this.$refs.nfcScanner.enableScanner()
      }
    },
    closeLinkedKeysForm() {
      this.showLinkedKeysForm = false
      this.fetchTables()
    },
    receiptPreview() {
      this.showPreviewReciept = true
    },
    printBill() {
      this.printing = true
      this.$store
        .dispatch('restaurantSale/counterCheckout/printBill', {
          stock_out_id: this.tableSelected.stock_out_id,
          counter_id: localStorage.getItem('counterId'),
          action_type: 'print-bill'
        })
        .then(() => { })
        .catch(error => {
          this.$notification['error']({
            message: 'Print Bill',
            description: error.messages,
            placement: 'bottomRight'
          })
        })
        .finally(() => {
          this.printing = false
        })
    },
    showShiftCloseForm() {
      this.showForm = true
      // Disable NFC scanner when shift close modal opens
      if (this.$refs.nfcScanner) {
        this.$refs.nfcScanner.disableScanner()
      }
    },
    changeLanguage(language) {
      this.$root.$i18n.locale = language.code
    },
    onCancelLock() {
      this.lock = true
      this.$modal.hide('modalLock')
    },
    onChangeLock() {
      if (!this.lock) {
        this.$modal.show('modalLock')
      }
    },
    onConfirmChangeLock() {
      this.lock = false
      this.$modal.hide('modalLock')
    },
    showPassword() {
      if (this.input_type === 'password') {
        this.input_type = 'text'
      } else {
        this.input_type = 'password'
      }
    },
    onUnlock() {
      this.loading = true
      this.errors = new Errors()
      this.$store
        .dispatch('security/user/unlock', { password: this.password })
        .then(() => {
          this.lock = false
          this.$modal.hide('modalLock')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
          this.password = null
        })
    },
    openFullscreen() {
      if (!this.fullscreen) {
        this.fullscreen = !this.fullscreen
      }
      let elem = document.documentElement

      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen()
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen()
      }
    },
    closeFullscreen() {
      if (this.fullscreen) {
        this.fullscreen = !this.fullscreen
      }
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
    },
    cancelOrder() {
      this.model.deleted_reason = null
      this.$confirm({
        title: this.$t('Are you sure to cancel order?'),
        content: h =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('restaurantSale.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.$store
            .dispatch('restaurantSale/counterCheckout/cancelOrder', {
              stock_out_id: this.tableSelected.stock_out_id,
              data: this.model
            })
            .then(response => {
              this.tableFetching = true
              this.$toasted.success(response.messages)
              this.$store
                .dispatch('restaurantSale/counterCheckout/fetchTables')
                .then(() => {
                  this.selected_table = 0
                  this.tableSelected = {}
                  this.$store.commit(
                    'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
                    {}
                  )
                  this.tableFetching = false
                })
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        }
      })
    },
    async startScan() {
      // Prevent multiple scans
      if (this.isScanning) {
        // console.log('NFC scanning already active, skipping...')
        return
      }

      if ('NDEFReader' in window) {
        try {
          // Clean up any existing reader first
          this.stopScan()

          // Create NDEFReader instance
          this.ndef = new window.NDEFReader()

          if (!this.ndef) {
            throw new Error(
              'Failed to create NDEFReader - constructor returned null'
            )
          }

          // console.log('NDEFReader created successfully:', this.ndef)

          // Add event listeners FIRST, before calling scan()
          this.ndef.addEventListener('reading', this.handleNFCReading)
          this.ndef.addEventListener('readingerror', this.handleNFCError)

          // console.log('Event listeners added successfully')

          // THEN call scan()
          await this.ndef.scan()
          this.isScanning = true

          // console.log('NFC scanning started successfully')

          // No notification - silent startup
        } catch (err) {
          console.error('StartScan error details:', err)
          this.isScanning = false
          this.ndef = null

          // Only show error notifications
          // this.$notification['error']({
          //   message: 'NFC Initialization Error',
          //   description: err.message || '⚠️ Failed to initialize NFC scanning.',
          //   placement: 'bottomRight'
          // })
        }
      } else {
        this.$notification['error']({
          message: 'Unsupported',
          description:
            'Web NFC is not supported in this browser. Please use Chrome on Android.',
          placement: 'bottomRight'
        })
      }
    },

    stopScan() {
      // console.log('Stopping NFC scan...')

      if (this.ndef) {
        try {
          this.ndef.removeEventListener('reading', this.handleNFCReading)
          this.ndef.removeEventListener('readingerror', this.handleNFCError)
          // console.log('Event listeners removed')
        } catch (error) {
          console.error('Error removing event listeners:', error)
        }
        this.ndef = null
      }

      this.isScanning = false
      // console.log('NFC scanning stopped')
    },

    handleNFCReading(event) {
      const { serialNumber, message } = event

      // Play scan sound immediately when NFC is detected
      this.playSound()

      // console.log('NFC Reading event:', event)
      // console.log('Serial Number:', serialNumber)

      // Global processing check
      if (this.isProcessingFee) {
        // console.log('Already processing a fee, ignoring scan')
        return
      }

      // Validate serial number exists
      if (!serialNumber || serialNumber.trim() === '') {
        this.$notification['warning']({
          message: 'Invalid Scan',
          description: 'No valid serial number detected from NFC tag.',
          placement: 'bottomRight'
        })
        return
      }

      let text = ''
      if (message && message.records) {
        for (const record of message.records) {
          if (record.recordType === 'text') {
            const decoder = new TextDecoder(record.encoding)
            text = decoder.decode(record.data)
          }
        }
      }

      // Set global processing flag
      this.isProcessingFee = true

      // Show immediate scan feedback
      // this.$notification['info']({
      //   message: 'Tag Detected',
      //   description: `Processing NFC tag: ${serialNumber.substring(0, 8)}...`,
      //   placement: 'bottomRight',
      //   duration: 1.5
      // })

      // Process the entrance fee
      // Normalize the serial number to match store format
      const normalizedSerial = this.hexSerialToDecimal(serialNumber.trim())
      this.handleAutoAddPreChargeProducts(normalizedSerial)

      // Reset global flag after processing
      setTimeout(() => {
        this.isProcessingFee = false
      }, 2000)
    },

    handleNFCError(event) {
      // console.log('NFC Error event:', event)
      this.$notification['error']({
        message: 'NFC Error',
        description: '⚠️ Cannot read NFC tag.',
        placement: 'bottomRight'
      })
    },

    // Normalize serial number format
    normalizeSerialNumber(serialNumber) {
      if (!serialNumber) return ''
      // Remove colons and convert to lowercase
      return serialNumber.replace(/:/g, '').toLowerCase()
    },

    // Convert hex serial number to decimal with byte reversal
    hexSerialToDecimal(serialNumber) {
      if (!serialNumber) return 0

      // Normalize the serial number (remove colons, lowercase)
      const normalized = this.normalizeSerialNumber(serialNumber)

      // Reverse byte order: split into pairs, reverse array, join back
      // "53f38476" -> ["53", "f3", "84", "76"] -> ["76", "84", "f3", "53"] -> "7684f353"
      const reversed = normalized
        .match(/.{2}/g)
        .reverse()
        .join('')

      // Convert reversed hex to decimal
      return parseInt(reversed, 16)
    },

    handleAutoAddPreChargeProducts(normalizedSerial) {
      // Prevent rapid duplicate calls for the same serial number
      const now = Date.now()
      const cooldownPeriod = 3000 // 3 seconds cooldown

      if (
        this.lastProcessedSerial === normalizedSerial &&
        now - this.lastProcessedTime < cooldownPeriod
      ) {
        // console.log('Duplicate scan detected, ignoring:', normalizedSerial)
        this.$notification['warning']({
          message: 'Duplicate Scan',
          description: 'Please wait before scanning the same card again.',
          placement: 'bottomRight',
          duration: 1.5
        })
        return
      }

      // Prevent processing the same serial number simultaneously
      if (this.processingSerialNumbers.has(normalizedSerial)) {
        // console.log('Already processing this serial number:', normalizedSerial)
        // this.$notification['warning']({
        //   message: 'Processing',
        //   description: 'This card is already being processed.',
        //   placement: 'bottomRight',
        //   duration: 1.5
        // })
        return
      }

      // Add to processing set
      this.processingSerialNumbers.add(normalizedSerial)

      try {
        // Use normalized serial to find table
        const table = this.$store.state.restaurantSale.counterCheckout.tables.find(
          t =>
            String(t.serial_card).padStart(10, '0') === normalizedSerial ||
            String(t.serial_card) === normalizedSerial ||
            parseInt(t.serial_card) === parseInt(normalizedSerial)
        )

        // console.log(
        //   'Available tables:',
        //   this.$store.state.restaurantSale.counterCheckout.tables.map(
        //     t => t.serial_card
        //   )
        // )
        // console.log('Looking for table with serial:', normalizedSerial)
        // console.log('Found table:', table)

        // Case 1: Serial number not found
        if (!table) {
          this.$notification['warning']({
            message: 'Invalid Serial Number',
            description: `The serial number: ${normalizedSerial} you entered was not found.`,
            placement: 'bottomRight'
          })
          return
        }

        // Case 2: Table status is not 1
        if (table.status_id !== 1) {
          // Update last processed info
          this.lastProcessedSerial = normalizedSerial
          this.lastProcessedTime = now
          this.onTableSelected(table)

          // this.$notification['warning']({
          //   message: 'Table Not Available',
          //   description:
          //     'The table you selected is not available. Please select another table.',
          //   placement: 'bottomRight'
          // })
          return
        }

        // Update last processed info
        this.lastProcessedSerial = normalizedSerial
        this.lastProcessedTime = now

        // Show success feedback
        // this.$notification['success']({
        //   message: 'Table Selected',
        //   description: `Table ${table.table_number ||
        //     table.name} selected successfully.`,
        //   placement: 'bottomRight',
        //   duration: 2
        // })

        // If passes both validations, continue
        this.onTableSelected(table)
      } catch (error) {
        console.error('Error in handleAutoAddPreChargeProducts:', error)
        this.$notification['error']({
          message: 'Processing Error',
          description:
            'An error occurred while processing the table selection.',
          placement: 'bottomRight'
        })
      } finally {
        // Remove from processing set after a short delay
        setTimeout(() => {
          this.processingSerialNumbers.delete(normalizedSerial)
        }, 1000)
      }
    },

    // Method to manually clear processing state if needed
    clearProcessingState() {
      this.processingSerialNumbers.clear()
      this.isProcessingFee = false
      this.lastProcessedSerial = null
      this.lastProcessedTime = 0
    },

    // Method to restart scanning if needed
    async restartScan() {
      this.stopScan()
      this.clearProcessingState()
      await this.$nextTick()
      this.startScan()
    },

    // handleNFCScan(scanData) {
    //   // Process the scanned value (your business logic here)
    // },

    handleScanStarted() {
      this.isScanning = true
    },

    handleScanEnded() {
      this.isScanning = false
    },

    handleScanSuccess(value) {
      this.playSound()
      this.handleAutoAddPreChargeProducts(value)
    },

    handleScanError(errorData) {
      console.log('Scan error:', errorData)
    },

    handleScannerReady() {
      this.scannerActive = true
    },

    // Method to manually clear scanner buffer if needed
    clearScannerBuffer() {
      if (this.$refs.nfcScanner) {
        this.$refs.nfcScanner.clearBuffer()
      }
    },

    initializeSounds() {
      try {
        // Option 1: Using base64 encoded beep sounds (works offline)
        const beepSound =
          'data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBTGH0fPTgjMGHm7A7+OZUQ0PVanm8LNnHwU7k9n0yoExBSh+zPLaizsIGGe57OihUQ0OUKXh8bllHgU7ktj0yoExBSh+zPLaizsIGGe57OihUQ0OUKXh8bllHgU7ktj0yoExBSh+zPLaizsIGGe57OihUQ0OUKXh8bllHgU7ktj0yoExBSh+zPLaizsIGGe57OihUQ0OUKXh8bllHgU7ktj0yoExBSh+zPLaizsIGGe57OihUQ0OUKXh8bllHgU7ktj0yoExBSh+zPLaizsIGGe57OihUQ0OUKXh8bllHgU7ktj0yoExBSh+zPLaizsIGGe57OihUQ0OUKXh8bllHgU7ktj0yoExBSh+zPLaizsIGGe57OihUQ0OUKXh8bllHgU7ktj0yoExBSh+zPLaizsIGGe57OihUQ0OUKXh8bllHgU7ktj0'

        // Create audio objects for different scenarios
        this.scanSound = new Audio(beepSound)
        this.scanSound.volume = 0.5

        this.successSound = new Audio(beepSound)
        this.successSound.volume = 0.7

        this.errorSound = new Audio(beepSound)
        this.errorSound.volume = 0.3
      } catch (error) {
        console.error('Failed to initialize sounds:', error)
      }
    },

    playSound(soundType = 'scan') {
      try {
        let sound = null

        switch (soundType) {
          case 'scan':
            sound = this.scanSound
            break
          case 'success':
            sound = this.successSound
            break
          case 'error':
            sound = this.errorSound
            break
          default:
            sound = this.scanSound
        }

        if (sound) {
          // Reset sound to beginning if it's already playing
          sound.currentTime = 0
          sound.play().catch(err => {
            console.warn('Could not play sound:', err)
          })
        }
      } catch (error) {
        console.error('Error playing sound:', error)
      }
    }
  },
  watch: {
    table_id: function (val) {
      if (val) {
        this.defaultCheckTable(val)
      }
    }
  }
}
</script>

<style scoped>
.pos-counter {
  height: 100vh;
}

@media (max-width: 991.98px) {
  .pos-counter {
    height: 111vh;
  }
}

.toggle-password {
  float: right;
  cursor: pointer;
  margin-right: 10px;
  margin-top: -30px;
  font-size: 15px;
}
</style>
